import { ISensor, ITrainer } from "./SensorManager";
import { CyclingPowerEventData } from "./CyclingPowerEventData";

export class VirtualSensor<T> implements ISensor<T>
{
    Value: T;

    constructor(defaultValue: T)
    {
        this.Value = defaultValue;
    }

    get name(): string {
        return "Virtual HR Sensor";
    }

    onDisconnected: (() => void) | null = null;

    private notification: (data: T) => void = () => {};

    async start(notification: (data: T) => void): Promise<void> {
        this.notification = notification;
        this.notification(this.Value);
    }

    disconnect(): void {
        this.notification = () => {};
    }
    
    setValue(value: T)
    {
        this.Value = value;
        this.notification(value);
    }
}

export class VirtualTrainer implements ITrainer
{
    onDisconnected: (() => void) | null = null;
    connect(): void {
        this.raiseCyclingPowerDataEvent();
    }
    disconnect(): void {
    }
    onCyclingPowerDataReceived: ((data: CyclingPowerEventData) => void) | null = null;
    get name(): string {
        return "Virtual Trainer";
    }

    private _targetPower: number = 0;
    public get targetPower(): number { return this._targetPower; }

    setTargetPower(power: number): void {
        console.log("Virtual Trainer: setTargetPower " + power);
        this._targetPower = power;
    }
    setTargetResistance(resistance: number): void {
        console.log("Virtual Trainer: setTargetResistance " + resistance);
    }

    private _currentPower: number = 0;
    private _currentCadence: number = 0;
    
    setPower(power: number)
    {
        this._currentPower = power;
        this.raiseCyclingPowerDataEvent();
    }

    setCadence(cadence: number)
    {
        this._currentCadence = cadence;
        this.raiseCyclingPowerDataEvent();
    }

    private raiseCyclingPowerDataEvent() {
        if (this.onCyclingPowerDataReceived != null) {
            let data = new CyclingPowerEventData(new Date());
            data.Power = this._currentPower;
            data.CrankRpm = this._currentCadence;
            this.onCyclingPowerDataReceived(data);
        }
    }
}

export default abstract class VirtualSensors
{
    static HRSensor: VirtualSensor<number>;
    static CPSensor: VirtualSensor<CyclingPowerEventData>;
    static Trainer: VirtualTrainer;

    static {
        this.HRSensor = new VirtualSensor(70);

        let defaultData = new CyclingPowerEventData(new Date());
        defaultData.Power = 0;
        defaultData.CrankRpm = 0;
        defaultData.WheelRpm = 0;
        this.CPSensor = new VirtualSensor(defaultData);
        this.Trainer = new VirtualTrainer();
    }
}